export const useSelectionColumnClick = (colId = 'ag-Grid-SelectionColumn') => {
  return (e) => {
    if (e.colDef.colId === colId && e.node.selectable) {
      e.node.setSelected(!e.node.isSelected())
    }
  };
};
